import { IUserState } from '../user/types';
import { CustomersState } from '../customers/types';

export enum Types {
  SEND_TAGGING = 'tagging/SEND_TAGGING',
  SEND_TAGGING_FAILURE = 'tagging/SEND_TAGGING_FAILURE',
  SEND_TAGGING_SUCCESS = 'tagging/SEND_TAGGING_SUCCESS'
}

export interface IEcommerceTagging {
  screenName?: string;
  currency?: string;
  value?: string;
  tipo_compra?: string;
  paginacao?: string;
  items?: IProductCardTagging[];
  search_term?: string;
  stage?: string;
  select_emissor?: string;
  item_list_name?: string;
  select_recebedor?: string;
  bp_emissor?: string;
  bp_recebedor?: string;
  nome_emissor?: string;
  nome_recebedor?: string;
  mensagem?: string;
  transaction_id?: string;
  sessionStatus?: string;
  modal_name?: string;
}
export interface IProductCardTagging extends relativeArtibutte {
  screenName?: string;
  price?: string;
  item_id: string;
  item_name: string;
  unidade_de_medida?: string;
  quantity?: string;
  tipo_compra?: string;
  item_category?: string;
  cod_gerdau?: string;
  preco_acordado?: boolean;
  favoritado?: boolean;
}

interface relativeArtibutte {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}
export interface ITaggingParams extends relativeArtibutte {
  page?: string;
  screenName?: string | null;
  event: string;
  itemName?: string;
  itemDescription?: string;
  filterInfo?: string;
  product?: string;
  nonInteraction?: boolean;
  orderCliente?: string;
  contratoObra?: string;
  order?: string;
  orderInfo?: string;
  type?: string;
  ecommerce?: IEcommerceTagging;
}

export interface ITaggingState {
  page?: string;
  userState: IUserState | null;
  customersState: CustomersState | null;
  screenName: string;
  event: string;
  itemName?: string;
  itemDescription?: string;
  filterInfo?: string;
  product?: string;
  nonInteraction?: boolean;
  orderCliente?: string;
  orderInfo?: string;
}
